import type { FC } from 'react';

import { Link } from '@/domains/core/routing/components/Link';
import { Rating as TamagoshiRatings } from '@/domains/core/tamagoshiTailwind/components/Rating/Rating';
import { rating } from '@/domains/core/tamagoshiTailwind/translations';
import { Gtm } from '@/domains/core/tracking/utils/Gtm';
import { useDetail } from '@/domains/productDiscovery/ProductPage/hooks/useDetail';
import { useReviewsStats } from '@/productDiscovery/ArticleReviews/ReviewsStats.ducks';

import { numberOfReview } from './translations';

export const Rating: FC = () => {
  const { title } = useDetail();
  const { average, total } = useReviewsStats();

  if (average === 0) return null;

  const goToReviews = () => {
    Gtm.push({
      event: 'interaction_click on ratings',
      e_category: 'navigation',
      e_action: 'Click on product ratings',
      event_trigger: title,
      amp_event_name: 'Click on ratings',
    });
    setTimeout(() => {
      const element = document.getElementById('reviews-container');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }, 700); // This is to make sure the scroll bring the user to the reviews, because it can fail when the client side components at the bottom of the page are not loaded yet
  };

  return (
    <Link
      href="#reviews-container"
      scroll={false}
      onClick={goToReviews}
      data-testid="reviews-link-header"
      shallow
    >
      <TamagoshiRatings
        aria-label={rating.ariaLabel}
        reviewsLabel={() => `${numberOfReview.format({ totalRating: total })}`}
        onClick={goToReviews}
        size="M"
        value={average}
        reviewsCount={total}
      />
    </Link>
  );
};

Rating.displayName = 'Rating';
